import React, { useMemo, useEffect } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Danger } from "../../../images/Danger.svg";
import {
  exitFullscreenFlag,
  submitExam,
} from "../../../redux/activityAsyncAction";
import { setFullscreen } from "../../../redux/features/fullScreen/fullScreenSlice";
import {
  deductTime,
  updateEnd,
} from "../../../redux/features/timer/timerSlice";

import "./exitFullscreenModal.scss";

const ExitFullscreenModal = () => {
  const isFullscreen = useSelector((state) => state.fullscreen.isFullscreen);
  const exitFullscreenCount = useSelector(
    (state) => state.fullscreen.exitFullscreenCount
  );
  const punishments = useSelector(
    (state) => state.examDetail?.details?.punishment
  );
  const availablePunishment = useMemo(() => {
    if (punishments) {
      return Object.keys(punishments).reduce((acc, punishment) => {
        if (punishments[punishment].status)
          return { name: punishment, punishment: punishments[punishment] };
        return acc;
      }, {});
    }
    return {};
  }, [punishments]);
  const examStarted = useSelector((state) => state.timer.examStarted);
  const dispatch = useDispatch();

  const isWarningShown = useMemo(
    () => exitFullscreenCount > 1,
    [exitFullscreenCount]
  );
  useEffect(() => {
    if (examStarted) {
      if (!isFullscreen && isWarningShown) {
        if (!availablePunishment?.name) return;
        switch (availablePunishment.name) {
          case "suspendExam":
            dispatch(updateEnd());
            console.log("suspendExam is true");
            dispatch(exitFullscreenFlag(availablePunishment.name));
            dispatch(submitExam());
            break;
          case "deductPoint":
            dispatch(exitFullscreenFlag(availablePunishment.name));
            break;
          case "deductTime":
            dispatch(deductTime());
            dispatch(exitFullscreenFlag(availablePunishment.name));
            break;

          default:
            break;
        }
      }
    }
  }, [
    examStarted,
    isFullscreen,
    availablePunishment,
    dispatch,
    isWarningShown,
  ]);

  console.log("this is the punishment", availablePunishment);

  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(true);
  return (
    <>
      <Modal
        className="exit-fullscreen-modal"
        show={!isFullscreen && examStarted}
        // show={show}
        // onHide={handleClose}
        animation={true}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body>
          <div className="d-flex flex-column align-items-center py-3 text-center">
            <Danger className="mb-4" />

            {!isWarningShown && (
              <>
                <h6 className="fw-bolder">Warning!!!</h6>
                <p className="mb-2">
                  You have exited full screen, note that when next you exit full
                  screen, one of the following actions would be taken.{" "}
                </p>
                <div className="bg-gray-200 w-100 px-2 my-4 rounded">
                  <p className="text-info text-start my-3">Point Deduction</p>
                  <p className="text-info text-start my-3">Time Deduction</p>
                  <p className="text-info text-start my-3">Exam Cancellation</p>
                </div>
              </>
            )}

            {isWarningShown && (
              <>
                <h6 className="fw-bolder">Alert!!!</h6>
                <p className="mb-2">You have exited full screen </p>
                {(availablePunishment?.name === "deductPoint" ||
                  availablePunishment?.name === "deductTime") && (
                  <p className="mb-5 text-danger">
                    The following action has been taken
                  </p>
                )}
                {availablePunishment?.name === "deductPoint" && (
                  <div className="bg-gray-200 w-100 px-2 rounded">
                    <p className="text-info text-start my-3">{`${
                      punishments.deductPoint.points
                    } Point${
                      punishments.deductPoint.points > 1 ? "s" : ""
                    } Deducted `}</p>
                  </div>
                )}
                {availablePunishment?.name === "deductTime" && (
                  <div className="bg-gray-200 w-100 px-2 rounded">
                    <p className="text-info text-start my-3">{`${
                      punishments.deductTime.timeInMinutes
                    } Minute${
                      punishments.deductPoint.timeInMinutes > 1 ? "s" : ""
                    } Deducted `}</p>
                  </div>
                )}

                {availablePunishment?.name === "suspendExam" && (
                  <div className="w-100 px-2">
                    <p className="text-danger text-start my-3">
                      {" "}
                      We regret to inform you that your assessment has ended as
                      a result of your action.
                    </p>
                  </div>
                )}
              </>
            )}
            <Button
              className="w-100 mt-3 enter-fullscreen-btn"
              size="lg"
              variant="primary"
              onClick={() => dispatch(setFullscreen(true))}
            >
              {"Enter fullScreen".toUpperCase()}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ExitFullscreenModal;
